import { defineComponent, PropType } from 'vue';
import { SearchCampaign } from '@studyportals/campaign-management-api-interface';
import SearchResultItemCode from '@/presentation/components/organisation-linking/import-campaign-configuration-modal/search-result-item/search-result-item.code';

export default defineComponent({
	props: {
		campaign: { type: Object as PropType<SearchCampaign>, required: true },
		onSelect: { type: Function as PropType<(campaign: SearchCampaign) => void>, required: true }
	},
	setup: (props) => {
		const code = new SearchResultItemCode(props.campaign, props.onSelect);

		return {
			campaign: props.campaign,
			formattedStartDate: code.formattedStartDate,
			formattedEndDate: code.formattedEndDate,
			isOverlapping: code.isOverlapping,
			handleSelect: code.handleSelect.bind(code)
		};
	}
});
